export default {
  namespaced: true,
  state: {
    dataList: [
      // {
      //   "img": "img/enterprise-cluster/01.png",
      //   "name": "太重集团榆次液压工业有限公司",
      //   "url": "http://www.tzyy.com.cn/index.htm",
      //   "authenticated": true,
      //   "type": "fwx"
      // },
      // {
      //   "img": "img/enterprise-cluster/02.png",
      //   "name": "经纬智能纺织机械有限公司",
      //   "url": "http://www.jwznfj.com/",
      //   "authenticated": true,
      //   "type": "fwx"
      // },
      // {
      //   "img": "img/enterprise-cluster/03.png",
      //   "name": "山西多尔晋泽煤机股份有限公司",
      //   "url": "http://www.sxdejz.com/",
      //   "authenticated": false,
      //   "type": "fwx"
      // },
      // {
      //   "img": "img/enterprise-cluster/04.png",
      //   "name": "海纳实业控股集团有限公司",
      //   "url": "https://hainacssp.com/",
      //   "authenticated": true,
      //   "type": "fwx"
      // },
      // {
      //   "img": "img/enterprise-cluster/05.png",
      //   "name": "山西建设投资集团有限公司",
      //   "url": "http://www.sxjgjt.com.cn/index.html",
      //   "authenticated": true,
      //   "type": "fwx"
      // },
      // {
      //   "img": "img/enterprise-cluster/06.png",
      //   "name": "中国信息通信研究院",
      //   "url": "http://www.caict.ac.cn/",
      //   "authenticated": true,
      //   "type": "fwx"
      // },
      // {
      //   "img": "img/enterprise-cluster/07.png",
      //   "name": "中国电信股份有限公司晋中分公司",
      //   "url": "https://www.ctyun.cn/",
      //   "authenticated": true,
      //   "type": "fwx"
      // }
    ]
  }
}
